import { render, staticRenderFns } from "./BarsIcon.vue?vue&type=template&id=245af4a3&"
import script from "./BarsIcon.vue?vue&type=script&lang=js&"
export * from "./BarsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports